import styled from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;

  > img {
    @media (${device.mobile}) {
      width: 127px;
      height: 64px;
    }
  }

  & > .page-title {
    font-size: 28px;
    line-height: 36px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    font-weight: 700;
    @media (${device.mobile}) {
      ${typography.headline2};
    }
  }

  .textContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    .title {
      ${typography.headline2};
      text-transform: uppercase;
      color: ${({ theme }) => theme.pending};

      &.issued {
        font-size: 24px;
        margin-top: 8px;
        line-height: 26px;
        margin-bottom: -4px;
      }
      @media (${device.mobile}) {
        ${typography.headline3};
        &.issued {
          margin-top: 0;
        }
      }
    }

    .authDescription .description {
      ${typography.body2regular}
    }

    .authDescription {
      ${typography.body2regular}
      text-align: center;
      font-weight: 700;
      max-width: 800px;
      width: 100%;
      &.issued {
        font-size: 20px;
        line-height: 26px;
      }
    }
  }

  & .bonuses-notice-box {
    margin-block: 0px 16px;
    width: min(480px, 100%);
    margin-inline: auto;

    &:empty {
      display: none;
      margin: 0;
    }
  }
`;
